import { Link } from "react-router-dom";
import { useT } from "../i18n/LanguageContext";

// Reusable GDPR double-consent (Privacy + Cancellation) used by both forms.
export function ConsentCheckboxes({
  agreePrivacy,
  setAgreePrivacy,
  agreeCancellation,
  setAgreeCancellation,
  errors,
  clearErr,
  privacyTestId,
  cancellationTestId,
  className = "",
}) {
  const t = useT();
  return (
    <div className={`space-y-3 ${className}`}>
      <label className={`flex items-start gap-3 cursor-pointer text-sm ${errors.agreePrivacy ? "text-red-400" : "text-white/70"}`}>
        <input data-testid={privacyTestId} type="checkbox" checked={agreePrivacy} onChange={(e) => { setAgreePrivacy(e.target.checked); clearErr("agreePrivacy"); }} className="accent-[#C5A059] h-4 w-4 mt-0.5 shrink-0" />
        <span>{t("form.consentPrivacy1")} <Link to="/privacy" target="_blank" rel="noopener noreferrer" className="text-[#C5A059] underline underline-offset-2">{t("form.privacyPolicy")}</Link>.</span>
      </label>
      <label className={`flex items-start gap-3 cursor-pointer text-sm ${errors.agreeCancellation ? "text-red-400" : "text-white/70"}`}>
        <input data-testid={cancellationTestId} type="checkbox" checked={agreeCancellation} onChange={(e) => { setAgreeCancellation(e.target.checked); clearErr("agreeCancellation"); }} className="accent-[#C5A059] h-4 w-4 mt-0.5 shrink-0" />
        <span>{t("form.consentPrivacy1")} <Link to="/cancellation-policy" target="_blank" rel="noopener noreferrer" className="text-[#C5A059] underline underline-offset-2">{t("form.cancellationPolicy")}</Link>.</span>
      </label>
      <p data-testid="consent-terms-note" className="text-xs text-white/50 pl-7 leading-relaxed">
        {t("form.termsNote")} <Link to="/terms" target="_blank" rel="noopener noreferrer" className="text-[#C5A059] underline underline-offset-2">{t("form.termsService")}</Link>.
      </p>
    </div>
  );
}
